import { apihubPost } from "./apihub";

/** POST `/getInteractedCustomerDetail/send-otp` — registration step 1 */
export function sendRegisterOtp(payload = {}) {
  return apihubPost("/getInteractedCustomerDetail/send-otp", payload);
}

/** POST `/getInteractedCustomerDetail/verify-otp` — registration step 2 */
export function verifyRegisterOtp(payload = {}) {
  return apihubPost("/getInteractedCustomerDetail/verify-otp", payload);
}
